import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import {
  SelectionTagsListDefinition,
  ISelectionTagsListMapperProps,
} from '../SelectionTagsList.types';
import { props as viewerPropsMapper } from './SelectionTagsList.mapper';

const props = composeMapper<
  PreviewWrapperProps<ISelectionTagsListMapperProps>,
  SelectionTagsListDefinition
>()(
  viewerPropsMapper,
  { add: ['compPreviewState', 'shouldResetComponent'] },
  (resolver, dependencies, carmiData) => {
    const { compPreviewState, shouldResetComponent } = dependencies;
    const viewerProps = resolver(dependencies, carmiData);
    return {
      ...viewerProps,
      previewWrapperProps: {
        compPreviewState,
        shouldResetComponent,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
